"use client";

import { MapPin, ArrowRight } from "lucide-react";
import Image from "next/image";
import { calculateReadingTime } from "../../../_helper/helper";
import Link from "next/link";

export function DestinationsSection({ lookUpCMSData, homeDetails }: any) {
  return (
    <section id="destinations" className="py-10 md:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {lookUpCMSData?.["Home - Section 7 : Blogs"] ? (
          <div
            dangerouslySetInnerHTML={{
              __html:
                lookUpCMSData?.["Home - Section 7 : Blogs"]?.Template?.trim(),
            }}
          />
        ) : (
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-2 bg-[#F9F7F4] px-6 py-3 rounded-full mb-6">
              <MapPin className="h-4 w-4 text-[#B42025]" />
              <span className="text-[#B42025] tracking-[0.3em] text-sm uppercase">
                Where We Are
              </span>
            </div>
            <h2 className="text-4xl md:text-6xl mb-6 text-[#1A1A1A]">
              Explore Our Destinations
            </h2>
            <p className="text-gray-600 text-xl max-w-3xl mx-auto">
              Each destination offers a different story, a different landscape,
              and a different emotion.
            </p>
          </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {homeDetails?.Blog?.slice(0, 2)?.map((blog: any, index: number) => {
            const readingTime = calculateReadingTime(blog?.Description || "");
            return (
              <div
                key={index}
                className="group relative overflow-hidden rounded-3xl aspect-[16/10] cursor-pointer shadow-xl hover:shadow-2xl transition-all duration-500"
              >
                <Link href={`/blogs/${blog?.BlogURL || ""}/`}>
                  <Image
                    src={blog?.BlogBannerImage}
                    alt={blog?.Title}
                    className="object-cover group-hover:scale-105 transition-transform duration-700"
                    fill
                    sizes="(max-width: 1024px) 100vw, 50vw"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />

                  <div className="absolute inset-0 p-8 lg:p-10 flex flex-col justify-end">
                    <div className="transform group-hover:translate-y-0 transition-transform duration-500">
                      {/* <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 px-4 py-2 rounded-full mb-4">
                    <MapPin className="h-4 w-4 text-[#C9A962]" />
                    <span className="text-white text-sm">{blog?.name}</span>
                  </div> */}

                      <h3 className="text-white text-xl lg:text-2xl mb-3 leading-tight">
                        {blog?.Title}
                      </h3>

                      {/* <div
                        suppressHydrationWarning={true}
                        className="text-white/90 text-lg mb-6 leading-relaxed max-w-lg"
                        dangerouslySetInnerHTML={{
                          __html: blog?.ShortDescription?.trim(),
                        }}
                      /> */}

                      <button className="inline-flex items-center gap-2 text-[#C9A962] hover:gap-4 transition-all duration-300 group/btn">
                        <span className="text-lg">{readingTime}</span>
                        <ArrowRight className="h-5 w-5" />
                      </button>
                    </div>
                  </div>

                  {/* <div className="absolute top-6 right-6">
                    <div className="w-16 h-16 border-2 border-white/30 rounded-full flex items-center justify-center backdrop-blur-sm">
                      <span className="text-white text-xl">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                    </div>
                  </div> */}
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
